/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="../../components/baseclasses/guid.ts" />
/// <reference path="../../components/models/meevo.model.custom.ts" />

module Meevo.Plugins.WalkinManagerKiosk {
    export class WalkinManagerKioskContext {

        itemsArrayCtrl: any;
        selectAllBox: boolean;
        mode: Meevo.Model.MaintenanceFormState;
        private backup: any;

        constructor(
            protected appSettings: Meevo.Components.Common.IAppSettings,
            protected dataService: Meevo.Components.BaseClasses.IDataService,
            protected modalService: Meevo.Components.Modal.IModalService) {

            this.mode = Meevo.Model.MaintenanceFormState.Readonly;
        }

        selectItem(item: any): void {
            if (this.isEditing) {
                if (item.clientsToMerge && item.clientsToMerge.length) {
                    for (let i = 0; i < item.clientsToMerge.length; i++) {
                        item.clientsToMerge[i].queuedForMerge = item.isSelected;
                    }
                }
                this.refreshSelectAll();
            }
        }

       

        selectAll(): void {
            if (this.isEditing) {
            
                let items = this.itemsArrayCtrl.pages[this.itemsArrayCtrl.currentPage];
                for (let i = 0; i < items.length; i++) {
                    items[i].isSelected = this.selectAllBox;
                    for (let j = 0; j < items[i].clientsToMerge.length; j++) {
                        items[i].clientsToMerge[j].queuedForMerge = this.selectAllBox;
                    }
                };
            }
        }

        selectIndividualMergeCandidate(item: any, mergeGroup: any): void {
            item.queuedForMerge = !item.queuedForMerge;

            let optIns = _.where(mergeGroup.clientsToMerge, { queuedForMerge: true });
            mergeGroup.isSelected = !(optIns && optIns.length === 0);

            this.refreshSelectAll();
        }

        edit(): void {
            this.takeBackup();
            this.refreshSelectAll();
            this.mode = Meevo.Model.MaintenanceFormState.Editing;
        }

        save(collapseAll: Function): void {
            //TODO: Isolate only the selected merge groups and extract the mergegroupid and clientids 
            //that should be merged.
            let aggregate = [];
            let mergeList = this.itemsArrayCtrl.pages[this.itemsArrayCtrl.currentPage];
            let showConfirmation = false;

            _.each(mergeList, (mergeGroup: any) => {
                let entry = { mergeGroupId: mergeGroup.mergeGroupId, clientsToMerge: [] };
                if (mergeGroup.isSelected) {
                    let optIns = _.where(mergeGroup.clientsToMerge, { queuedForMerge: true });
                    if (optIns.length === 1) {
                        // Only one merge candidate was selected, which makes no sense... so clear them.
                        mergeGroup.isSelected = false;
                        _.each(mergeGroup.clientsToMerge, (item: any) => {
                            item.queuedForMerge = false;
                        });
                    }
                    else {
                        _.map(optIns, (item: any) => {
                            entry.clientsToMerge.push(item.clientTId);
                        });
                        showConfirmation = true;
                    }
                }
                aggregate.push(entry);
            });

            if (showConfirmation) {
                this.modalService.confirm("MESSAGE_MERGE_CONFIRMATION", Meevo.Components.Modal.ModalTranslationModes.Translate)
                    .then((response: boolean) => {

                        this.dataService.add(this.appSettings.API_ENDPOINTS.clientMerge, { itemsToMerge: aggregate })
                            .then((updateResponse: any) => {
                                collapseAll();
                                this.mode = Meevo.Model.MaintenanceFormState.Readonly;
                                return response;
                            });

                        return response;
                    });
            }
            else {
                this.dataService.add(this.appSettings.API_ENDPOINTS.clientMerge, { itemsToMerge: aggregate })
                    .then((updateResponse: any) => {
                        collapseAll();
                        this.mode = Meevo.Model.MaintenanceFormState.Readonly;
                        return updateResponse;
                    });
            }

        }

        cancel(): void {
            this.rollbackChanges();
            this.refreshSelectAll();
            this.mode = Meevo.Model.MaintenanceFormState.Readonly;
        }

        onPageLoaded(): void {
            this.refreshSelectAll();
        }

        get isEditing(): boolean {
            return this.mode == Meevo.Model.MaintenanceFormState.Editing;
        }

        get isReadonly(): boolean {
            return this.mode == Meevo.Model.MaintenanceFormState.Readonly;
        }

        private takeBackup() {
            this.backup = angular.copy(this.itemsArrayCtrl.pages[this.itemsArrayCtrl.currentPage]);
        }

        private rollbackChanges() {
            this.itemsArrayCtrl.pages[this.itemsArrayCtrl.currentPage] = angular.copy(this.backup);
            this.backup = null;
        }

        private refreshSelectAll(): void {
            let items = this.itemsArrayCtrl.pages[this.itemsArrayCtrl.currentPage];
            let selectedCount = _.where(items, { isSelected: true });

            if (items && selectedCount) {
                this.selectAllBox = (items.length === selectedCount.length);
            }
        }

    }
}